import { StateUtils } from '@spartacus/core';
import { AccountingCodeList } from '../../../../../core/model';
import { loaderReducer } from '../../../../../core/state/utils/loader';
import { CartActions } from '../actions';
import { CartAccountingCodesActionTypes } from '../actions/cart-accounting-codes.action';
import { AccountingCodesState, CART_ACCOUNTING_CODES } from '../cart-state';

export const initialState: AccountingCodesState = undefined;
export const AccountingCodeListInitialState: AccountingCodeList = undefined;

export function accountingCodesReducer(
  state = initialState,
  action: CartActions.CartAccountingCodesActions | StateUtils.LoaderAction
): AccountingCodesState {
  switch (action.type) {
    case CartAccountingCodesActionTypes.SetAccountingCodesModalOpen: {
      const _action = <CartActions.SetAccountingCodesModalOpen>action;

      return { ...state, isModalOpen: _action.payload.isModalOpen, active: _action.payload.active || state.active };
    }
    case CartAccountingCodesActionTypes.SetAccountingCodesModalDismissed: {
      const _action = <CartActions.SetAccountingCodesModalOpen>action;

      return { ...state, isModalDismissed: _action.payload.isModalDismissed };
    }
    case CartAccountingCodesActionTypes.LoadAccountingCodeListSuccess: {
      const _action = <CartActions.LoadAccountingCodeListSuccess>action;
      const loaderState = loaderReducer<AccountingCodeList>(CART_ACCOUNTING_CODES, AccountingCodeListReducer)(undefined, _action);

      return { ...state, accountingCodeList: loaderState };
    }
    case CartAccountingCodesActionTypes.LoadAccountingCodeList:
    case CartAccountingCodesActionTypes.LoadAccountingCodeListFail: {
      const _action = <CartActions.LoadAccountingCodeListFail>action;
      const loaderState = loaderReducer<AccountingCodeList>(CART_ACCOUNTING_CODES, AccountingCodeListReducer)(undefined, _action);

      return { ...state, accountingCodeList: loaderState };
    }
    default: {
      return state;
    }
  }
}

export function AccountingCodeListReducer(
  state = AccountingCodeListInitialState,
  action:
    | CartActions.LoadAccountingCodeList
    | CartActions.LoadAccountingCodeListFail
    | CartActions.LoadAccountingCodeListSuccess
    | StateUtils.LoaderAction
): AccountingCodeList {
  switch (action.type) {
    case CartAccountingCodesActionTypes.LoadAccountingCodeListSuccess: {
      return action.payload ? action.payload : AccountingCodeListInitialState;
    }
    default: {
      return state;
    }
  }
}
